import { Navigate } from '@tanstack/react-router';
import { AnalyticsSupportedSocialMediaType } from '@anytag/shared-types';
import { useAnalyticsProfileContext } from '../analytics-profile-context';
import { AnalyticsFacebookDashboard } from './analytics-facebook-dashboard';
import { AnalyticsInstagramDashboard } from './analytics-instagram-dashboard';
import { AnalyticsTwitterDashboard } from './analytics-twitter-dashboard';
import { AnalyticsYoutubeDashboard } from './analytics-youtube-dashboard';

// TODO: Seem we don't check `subscriptionPlan.availableFeatures?.dashboardEnabled` like other tab flows (based old source code).
export const AnalyticsDashboard = () => {
  const { selectedSocialAccount } = useAnalyticsProfileContext();

  switch (selectedSocialAccount.socialMedia) {
    case AnalyticsSupportedSocialMediaType.instagram:
      return <AnalyticsInstagramDashboard />;
    case AnalyticsSupportedSocialMediaType.twitter:
      return <AnalyticsTwitterDashboard />;
    case AnalyticsSupportedSocialMediaType.facebook:
      return <AnalyticsFacebookDashboard />;
    case AnalyticsSupportedSocialMediaType.youtube:
      return <AnalyticsYoutubeDashboard />;
    default:
      return <Navigate to="/analytics" />;
  }
};
